module.exports = {
	__API_DOMAIN__:"apy.phainbp.work"
}